var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoArtstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 53,
    viewBox: "0 0 298 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_18543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5452 11.8423L100.305 40.8787H94.9317L92.8611 34.4508H82.8046L80.8195 40.8901H75.4462L85.206 11.8537L90.5452 11.8423ZM84.2991 29.6798H91.3609L87.7615 18.4466L84.2991 29.6798Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.401 40.8674V11.9277H116.687C121.736 11.9277 124.753 14.9794 124.753 18.2873V24.4362C124.753 26.7477 123.185 28.9909 120.452 30.0954L125.335 40.8674H119.711L115.147 30.7103H109.808V40.8674H104.401ZM109.78 16.7159V25.962H116.277C117.988 25.962 119.42 24.9713 119.42 23.2804V19.443C119.42 17.6667 117.931 16.7159 116.066 16.7159H109.78Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.386 40.8674V16.676H128.187V11.9277H147.342V16.676H140.725V40.8674H135.386Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.833 32.6121V34.4511C153.833 37.0131 156.235 38.9546 159.338 38.9546H162.76C165.943 38.9546 168.424 37.4231 168.424 34.7415V32.7431C168.424 28.2851 152.418 27.4539 152.418 19.819V17.2114C152.418 14.2793 155.191 11.7173 158.91 11.7173H162.76C166.936 11.7173 169.999 14.4843 169.999 17.6669V20.2688H167.597V18.0768C167.597 15.6856 165.367 13.8694 162.555 13.8694H159.241C156.799 13.8694 154.814 15.4749 154.814 17.5815V19.6881C154.814 25.3815 170.826 26.1273 170.826 32.4072V35.1742C170.826 38.8066 167.472 41.1181 162.965 41.1181H159.241C154.734 41.1181 151.426 38.2258 151.426 34.8553V32.6235L153.833 32.6121Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.793 40.8675V14.0743H174.682V11.9678H192.935V14.0743H185.189V40.8675H182.793Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.872 11.7627L216.089 40.8674H213.653L210.424 31.6042H198.839L195.656 40.8902H193.215L203.482 11.7855L205.872 11.7627ZM199.598 29.4123H209.689L204.646 14.8371L199.598 29.4123Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.571 40.8675V14.0743H216.465V11.9678H234.718V14.0743H226.972V40.8675H224.571Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.086 40.8675V11.9678H242.482V40.8675H240.086Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.353 41.1176C253.36 41.1176 250.508 38.2253 250.508 34.8548V17.9966C250.508 14.6091 253.405 11.7339 257.353 11.7339H263.103C267.033 11.7339 269.885 14.6261 269.885 17.9966V34.8435C269.885 38.2254 267.033 41.1062 263.103 41.1062L257.353 41.1176ZM262.897 38.9712C263.495 38.9811 264.088 38.8717 264.643 38.6495C265.198 38.4273 265.703 38.0968 266.128 37.6773C266.553 37.2578 266.89 36.7578 267.118 36.2067C267.347 35.6555 267.464 35.0643 267.461 34.4677V18.3667C267.464 17.7704 267.347 17.1794 267.118 16.6286C266.889 16.0777 266.553 15.5781 266.127 15.1591C265.702 14.74 265.198 14.4101 264.643 14.1885C264.088 13.9669 263.495 13.8583 262.897 13.8689H257.478C256.878 13.8544 256.282 13.9602 255.724 14.1801C255.166 14.3999 254.658 14.7293 254.229 15.1487C253.801 15.5681 253.462 16.069 253.231 16.6218C253 17.1746 252.883 17.7679 252.886 18.3667V34.4506C252.882 35.0499 252.999 35.6439 253.229 36.1973C253.46 36.7507 253.799 37.2523 254.227 37.6723C254.656 38.0924 255.164 38.4223 255.722 38.6424C256.281 38.8626 256.878 38.9686 257.478 38.9541L262.897 38.9712Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.933 40.8674V11.9676H280.415L294.938 36.6599V11.9277H297.333V40.8674H294.852L280.335 16.1352V40.8674H277.933Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333374 40.8618L5.42722 49.6581C5.93383 50.6635 6.71049 51.5084 7.67045 52.0986C8.63041 52.6887 9.73586 53.0009 10.8633 53.0002H44.7006L37.6844 40.8618H0.333374Z",
    fill: "#13AFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6666 40.9243C60.6692 39.755 60.3324 38.61 59.6969 37.6278L39.8748 3.23386C39.356 2.2577 38.5806 1.44095 37.632 0.871237C36.6833 0.301523 35.5972 0.000341617 34.4901 0H24.0115L54.6316 52.9488L59.4573 44.6079C60.4099 42.991 60.6666 42.3021 60.6666 40.9243Z",
    fill: "#13AFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6933 32.2362L19.0089 8.58008L5.32458 32.2362H32.6933Z",
    fill: "#13AFF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_18543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297,
    height: 53,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArtstation);
export default __webpack_public_path__ + "static/media/logo-artstation.a0a72923aec9e06c6a0a6ca0fbf49e79.svg";
export { ForwardRef as ReactComponent };